export default "__VITE_ASSET__fb0fb686__"